export default __webpack_public_path__ + "static/11_36-c8aff24e5c14091094d20bcd2949392e.png";